import classNames from "classnames";
import { useAnalyticsModalContext } from "PFApp/analytics/parts/top_actions_panel/analytics_modal_context_provider";
import { ReportType } from "PFApp/analytics/types/export_analytics";
import { Select } from "PFComponents/select/select";
import React, { JSX, useMemo } from "react";
import { useTranslation } from "react-i18next";

import css from "./report_type_selector.module.scss";

interface ReportTypeSelectorProps {
  disabled: boolean;
}

type Option = {
  id: ReportType;
  item: ReportType;
  displayElement: string;
};

export const ReportTypeSelector = ({ disabled }: ReportTypeSelectorProps): JSX.Element => {
  const {
    updateData,
    state: {
      data: { reportType }
    }
  } = useAnalyticsModalContext();
  const { t } = useTranslation("insights", { keyPrefix: "exportWizard" });

  const options: Option[] = useMemo(
    () => Object.values(ReportType).map((id) => ({ id, item: id, displayElement: t(`reportTypes.${id}`) })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const selectedIndex = useMemo(() => {
    const index = options.findIndex((i) => i.id === reportType);
    return index < 0 ? 0 : index;
  }, [options, reportType]);

  return (
    <div className={css.root}>
      <p className={classNames(css.label, { [css.disabled]: disabled })}>
        {t("selectFieldsAndFiltersMyself")}
      </p>
      <Select
        /* @ts-ignore */
        readOnly
        controlledValue
        kind="bordered"
        className={css.select}
        disabled={disabled}
        options={options}
        handleChange={(value: ReportType) =>
          updateData({
            reportType: value,
            ...(reportType !== value ? { selectedFields: [], selectedFilters: {} } : {})
          })
        }
        selectedIndex={selectedIndex}
        displayValues={<div className={css.optionValue}>{options[selectedIndex]?.displayElement}</div>}
      />
    </div>
  );
};
